/**
 * Created by Florin David on 04/01/2017.
 */
import json from '../../package.json'

export default json.version
